<script type="text/ecmascript-6">
import GeneralMixin from "JS/mixins/campaign/general";

export default {
  name: "Header",
  mixins: [GeneralMixin],
  props: {
    logoImageAltText: {
      type: String,
      default: ""
    },
    logoImageSource: {
      type: String,
      default: ""
    },
    campaignDesignColors: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
